import React from "react";

export default function DescriptionInput({ description, setDescription }) {
  return (
    <div className="input-container">
      <label htmlFor="description" className="input-label">
        Rug Description
      </label>
      <textarea
        id="description"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />
    </div>
  );
}
